import type { NiveauAnomalieImportPes } from '../../services/pes/importPes';

/** Fichiers acceptés à l'import : flux XML seuls, ou zip de flux et de leurs pièces jointes. */
export const TYPES_ACCEPTES = {
	'text/xml': ['.xml'],
	'application/xml': ['.xml'],
	'application/zip': ['.zip'],
	'application/x-zip-compressed': ['.zip'],
};

/** Même limite que l'API (import_pes.tailleMax) : un fichier plus gros est refusé avant l'envoi. */
export const TAILLE_MAX = 50 * 1024 * 1024;

/** Présentation de chaque niveau d'anomalie, du plus grave au moins grave. */
export const NIVEAUX: Record<
	NiveauAnomalieImportPes,
	{
		titre: string;
		singulier: string;
		description: string;
		couleur: 'red' | 'orange' | 'blue';
		icone: 'OctagonX' | 'TriangleAlert' | 'Info';
	}
> = {
	bloquant: {
		titre: 'Bloquants',
		singulier: 'Bloquant',
		description:
			"À corriger dans le fichier : tant qu'il en reste, rien n'est importé.",
		couleur: 'red',
		icone: 'OctagonX',
	},
	avertissement: {
		titre: 'Avertissements',
		singulier: 'Avertissement',
		description:
			"L'import est possible : à vérifier, ou à corriger pour un prochain envoi.",
		couleur: 'orange',
		icone: 'TriangleAlert',
	},
	information: {
		titre: 'Informations',
		singulier: 'Information',
		description:
			"Ce que l'import va faire en plus des pièces (tiers créés ou complétés…).",
		couleur: 'blue',
		icone: 'Info',
	},
};

export const ORDRE_NIVEAUX: NiveauAnomalieImportPes[] = [
	'bloquant',
	'avertissement',
	'information',
];

/** Libellés du résumé, dans l'ordre d'affichage ; les clés inconnues sont ignorées. */
export const LIBELLES_RESUME: [string, string][] = [
	['flux', 'Fichiers XML'],
	['bordereaux', 'Bordereaux'],
	['pieces', 'Pièces'],
	['lignes', 'Lignes'],
	['tiersCrees', 'Tiers créés'],
	['tiersCompletes', 'Tiers complétés'],
	['imputationsCreees', 'Imputations créées'],
];
